import type { ReactNode } from 'react';
import './TourBadge.css';

export type TourBadgeTone = 'draft' | 'new' | 'removed' | 'muted' | 'admin';

interface TourBadgeProps {
  tone: TourBadgeTone;
  children: ReactNode;
  'data-testid'?: string;
}

/**
 * A status pill on a tour or a step. Text, not colour alone, carries the meaning: the tones only
 * separate "needs attention" from "for information", which is all colour can honestly do here.
 */
export const TourBadge = ({ tone, children, 'data-testid': testId }: TourBadgeProps) => (
  <span className={`tour-badge tour-badge--${tone}`} data-testid={testId}>
    {children}
  </span>
);
